import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { deleteTask, fetchChecklist } from '../../../actions/ChecklistActions';
import { hideModal } from '../../../actions/ModalActions';

function DeleteTaskModal(props) {
  const { onSubmit, onCancel, tasksById, taskId } = props;

  return (
    <div>
      <div className="modal-header">
        <h3 className="modal-title">Delete Task</h3>
      </div>
      <div className="modal-body text-center">
        <p>Are you sure you want to delete this task from your checklist?</p>
        <p><strong>{tasksById[taskId].title}</strong></p>
        <p>This cannot be undone</p>
        <ul className="list-inline">
          <li><a role="button" className="btn btn-primary" onClick={() => onSubmit(taskId)}>Delete</a></li>
          <li><a role="button" className="btn btn-secondary" onClick={onCancel}>Cancel</a></li>
        </ul>
      </div>
    </div>
  );
}

DeleteTaskModal.propTypes = {
  tasksById: PropTypes.shape({}),
  taskId: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

const connectStateToProps = (state) => {
  const tasksById = state.checklist.tasks.byId;

  return {
    tasksById
  };
};

const connectDispatchToProps = (dispatch, ownProps) => (
  {
    onSubmit: (taskId) => {
      dispatch(deleteTask(taskId)).then(() => {
        dispatch(hideModal());
        if (ownProps.callback) ownProps.callback();
        dispatch(fetchChecklist());
      });
    },
    onCancel: () => dispatch(hideModal())
  }
);

export default connect(
  connectStateToProps,
  connectDispatchToProps
)(DeleteTaskModal);



// WEBPACK FOOTER //
// ./src/components/manage/checklist/DeleteTaskModal.jsx